import React, { Component } from "react";
import styled from "styled-components";
import moment from 'moment';
import { SecondaryButton, DefaultModuleHeader, ButtonSizeOptions, ImageLoader, ButtonIcon } from "@loanbossinc/component-library";
import { AddCircleOutline } from "@material-ui/icons";
const StyledImageHeader = styled.div`
&& {
    height: 30px;
    width: 30px;
    margin: 0.2em;
    margin-bottom: 0.4em;
    display: inline-block;
    vertical-align: top !important;
}`;

const StyledImageLoader = styled(ImageLoader)`
   && {
       height: 30px;
       width: 30px;
       margin: 0.2em;
   } 
`;

const StyledButton = styled(AddCircleOutline)`
    &&&& {
        padding-top: 0.3em;
        padding-left: 0.3em;
        color: #005AA9;
        height: 20px;
        width: 20px;
        cursor: pointer;
        margin-top: 7px;
        margin-left: 7px;
    }
`;
export class QuoteHistoryHeader extends Component {

    getHeaderImages = (elements) => {
        
        const { authentication } = this.props;
        if (elements && elements.length > 0 && authentication) {
            return elements.reduce((accum, cur, index) => {                
                if (!cur || !cur.lenderCompany || !cur.lenderCompany.name) return accum;
                accum.push(
                    <StyledImageHeader key={index}>
                        <StyledImageLoader src={cur.logo} defaultImage={process.env.PUBLIC_URL + "/images/default-lender-icon.svg"} title={cur.lenderCompany.name} key={index} />
                    </StyledImageHeader>);
                return accum;
            }, []);
        }

        return [];
    }

    getHeadingTitle = () => {
        const { loans, title } = this.props;
        if (!loans.length) return null;
        return `${loans.length} ${title} ${loans.length > 1 ? "Quotes": "Quote"}`;
    }

    getSubTitle = (uniqueLenders) => {
        if (uniqueLenders && uniqueLenders.length > 0) {
            const lenderNames = uniqueLenders.reduce((accum, cur) => {
                if (!cur || !cur.lenderName) return accum;
                accum.push(cur.lenderName);
                return accum;
            }, []).join(", ");
            return lenderNames.length > 60 ? lenderNames.slice(0, 60) + "..." : lenderNames;
        }

    }



    render() {
        const { distinctLenders } = this.props;
        return (
            <DefaultModuleHeader
                headerElement={this.getHeaderImages(distinctLenders)}
                headerTitle={this.getHeadingTitle()}
                subTitle={this.getSubTitle(distinctLenders)}
            />
        )
    }
}